import { useQuery } from "@tanstack/react-query";

import { forbiddenLocations } from "app/components/campaigns/campaigns-wizard/CampaignsWizardConsts";
import { createActivationApi } from "app/pages/activation/services/api";

const RT_COUNTRIES_QUERY_KEY = "RT_COUNTRIES_QUERY_KEY";

export const useGetRTCountriesQuery = (enabled = true) => {
    return useQuery({
        queryKey: [RT_COUNTRIES_QUERY_KEY],
        queryFn: async () => {
            const { rankTracker } = createActivationApi();

            return await rankTracker.getCountries();
        },
        enabled,
        staleTime: Infinity,
        select: (data) =>
            data.filter(({ name }) => !forbiddenLocations.includes(name)).sort((a, b) => a.name.localeCompare(b.name)),
    });
};
